import { SESSION_MANAGER_HOST } from '@/constants';
import httpClient from '@/modules/cart/services/api/client';

export const gestSignIn = async () => {
  return await httpClient.get(`${SESSION_MANAGER_HOST}/guest/sign-in`);
};
